import React from "react";
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { toast } from 'react-toastify';
import PageTitle from "../common/PageTitle";
import Select from "react-select";
import countryCodes from "../constants/countryCodes";
import deviceService from "../../services/deviceService";
import organizationService from "../../services/organizationService";
import Steper from "../common/steper";

const preperdCodes = countryCodes.map(code => {
    return { value: code.code, label: code.country, dialingCode: code.dialingCode };
});

export default class AddDevice extends React.Component {
    constructor(props) {
        super(props);

        const organization = this.props.location.state ? this.props.location.state.detail : null
        let landlineNumber = '', selectedCountry = null, dialingCode = '', countryCode = '', callerId = ''
        if (organization && organization.device) {
            landlineNumber = organization.device.landlineNumber
            let findCountry = countryCodes.find(element => element.code === organization.device.countryCode);
            countryCode = organization.device.countryCode
            callerId = organization.device.callerId
            selectedCountry = findCountry.code
            dialingCode = findCountry.dialingCode
        }

        this.state = {
            organization,
            organizationId: this.props.match.params.id,
            selectedCountry, landlineNumber,
            countries: preperdCodes,
            serialNo: this.props.match.params.id,
            type: 0,
            countryCode,
            dialingCode,
            callerId
        };

        this.options = {
            autoClose: 3000,
            hideProgressBar: true,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleSubmitDevice = this.handleSubmitDevice.bind(this);
        this.skipCallerId = this.skipCallerId.bind(this)
    }

    componentDidMount() {
        if (!this.state.organization) {
            this.loadOrganizationById()
        }
    }

    loadOrganizationById() {
        const { countries } = this.state
        organizationService.getById(this.state.organizationId).then(organization => {

            let landlineNumber = '', selectedCountry = null, dialingCode = '', countryCode = '', callerId = ''
            if (organization && organization.device) {
                landlineNumber = organization.device.landlineNumber
                let findCountry = countries.find(element => element.value === organization.device.countryCode);
                countryCode = organization.device.countryCode
                callerId = organization.device.callerId
                if (findCountry) {
                    selectedCountry = findCountry
                    dialingCode = findCountry.dialingCode
                }
            }

            this.setState({
                organization,
                selectedCountry, landlineNumber,
                countryCode,
                dialingCode,
                callerId,
                name: organization.name
            })
        }).catch(error => {
            toast.error("Error loading organization", this.options)
        });
    }

    handleChange = event => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleCountryChange = selected => {
        this.setState({
            countryCode: selected.value,
            dialingCode: selected.dialingCode,
            selectedCountry: selected
        });
    };

    handleSubmitDevice = event => {
        const { dialingCode, landlineNumber, countryCode } = this.state
        event.preventDefault();
        let device = {
            callerId: dialingCode + landlineNumber,
            landlineNumber,
            countryCode,

        }
        deviceService.update(this.state.organization._id, this.state.organization._id, device).then(response => {
            toast.success("Caller Id is successfully updated!", this.options);
            this.props.history.push("/dashboard/organizations");
        }).catch(error => {
            toast.error(error.response, this.options)
        })
    }

    skipCallerId() {
        this.props.history.push("/dashboard/organizations");
    }

    isValid() {
        return this.state.dialingCode && this.state.landlineNumber
    }

    render() {
        const { selectedCountry, countries, landlineNumber, dialingCode } = this.state;

        return (
            <div>
                <Row noGutters className="page-header pt-4">
                    <PageTitle title="Update Caller Id" subtitle="Manage caller Id" className="text-sm-left" />
                    <Col sm="12" md="12" lg="8" xl="6">
                        <p className="m-0 light-grey">
                            Organization is an essential part of AirTouch system. In order to use the application at least one organization must be created and plan must be purchased.
                            After you Purchase a plan simply add users to the organization and you are ready to go.
                    </p>
                    </Col>
                </Row>
                <Steper step={3} />
                <Row>
                    <Col sm="12" md="12" lg="8" xl="6">
                        <Card className="mb-4 card-custom" >
                            <CardHeader className="border-bottom card-header-custom">
                                <h6 className="text-white">Update Caller Id</h6>
                            </CardHeader>
                            <CardBody >

                                <form className="form-wrapper" onSubmit={this.handleSubmitDevice}>
                                    <div className="margin-top-10">
                                        <label className="text-white" htmlFor="">Select country:</label>
                                        <Select
                                            value={selectedCountry}
                                            onChange={this.handleCountryChange}
                                            options={countries}
                                        />
                                    </div>

                                    {dialingCode ? <div className="form-group margin-top-10">
                                        <label className="text-white" htmlFor="landlineNumber">Caller Id:</label>
                                        <div className="input-code">
                                            <span>
                                                + {dialingCode}
                                            </span>
                                            <input
                                                type="number"
                                                className="form-control bordered"
                                                name="landlineNumber"
                                                id="landlineNumber"
                                                value={landlineNumber}
                                                placeholder="Enter mobile number"
                                                onChange={this.handleChange}
                                            />
                                        </div>

                                    </div> : null}
                                    <hr />
                                    <div className="clearfix pull-right card-list-btns">
                                        <button className="btn btn-lightblue"
                                            onClick={this.skipCallerId}
                                        > {this.props.location.state && this.props.location.state.detail ? 'Skip' : 'Cancel'} </button>
                                        {this.isValid() ? <button type="submit" className="btn btn-lightblue"
                                        // onClick={() => this.props.handleSubmitDevice(this.state)}
                                        > Submit </button> : null}
                                    </div>

                                </form>
                            </CardBody >
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/organizationComponent/addDevice.js